import { IFilter } from "../basic-filter-applied/basic-filter-applied.component";


export class BasicGridState {
    basicGridRequest?: IFilter[];
    basicGridForm: string;
}
